// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__22lr-","large":"styles_large__1XB7c"};